import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import type { JackpotVariant } from '../../types';

/**
 * JackpotContainer is a presentational component that wraps its children with a styled div.
 * It applies a set of utility classes for background, layout, and padding, and merges any additional classes provided via the className prop.
 * It inherits HTMLDivElement.
 * @param variant - The variant of the jackpot container (default or sticky).
 * @returns The styled container wrapping the provided children.
 */
function JackpotContainer({ variant, className, ...props }: { variant: JackpotVariant } & ComponentProps<'div'>) {
  const classes = twMerge('dark bg-secondary ll-grid-container items-center gap-y-6 w-full', className, variant === 'sticky' && 'py-5 rounded-md [--ll-container-padding:24px]');
  return <div className={classes} {...props} />;
}

export { JackpotContainer };
